/** What the key uses when the link session has no `userId` yet. It is never a real account. */
export const UNKNOWN_ACCOUNT_KEY_PART = 'unknown';

/**
 * Cache key of the account status, one per account.
 *
 * The account id is part of it because the browser holds one link session at a time: without it the
 * status of the previous link would answer for the next one.
 */
export const accountStatusKey = (userId: string | null) =>
  ['identity', 'account', 'status', userId ?? UNKNOWN_ACCOUNT_KEY_PART] as const;
